// extracted by mini-css-extract-plugin
export default {"root":"Signup_root__ATX4S","button_container":"Signup_button_container__cQ5WN","link":"Signup_link__ZCLFt","signup":"Signup_signup__JEGqJ","message":"Signup_message__PWH1i"};